import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import { List, SearchInput, useListContext, TopToolbar, FilterButton, SortButton, useGetResourceLabel, TextInput, BooleanInput } from "react-admin";
import MobileGrid from "./MobileGrid";
import CoreCreateButton from "../../../../shared/components/core/CoreCreateButton";
import { instrumentExporter } from "../../../../shared/utilities/adminExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_INSTRUMENT_C" />
        <SortButton fields={['name', 'code']} />
        <FilterButton />
        <SacopExportButton exporter={instrumentExporter} />
    </TopToolbar>
);

const instrumentFilters = [
    <SearchInput source="q" alwaysOn />,

    <TextInput source="name" />,
    <BooleanInput source="active" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    return (
        <MobileGrid  {...listContext} />
    );
}

const InstrumentList = () => {
    return (<List
        filterDefaultValues={ { active: true }}
        sort={{ field: 'code', order: 'ASC' }}
        perPage={25}
        filters={instrumentFilters}
        actions={<ListActions />}
        exporter={instrumentExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default InstrumentList;
